import { PortableText } from "next-sanity";
import { PortableTextComponents } from "../portableText/PortableTextComponents";

export const RichTextBlock = ({ content }: { content: any }) => {
    return (
        <section className="container">
            <div className="mx-2.5 md:mx-5 rich-text ">
                <PortableText value={content.textContent} components={PortableTextComponents} />
            </div>
        </section>
    );
};
